import React, { useState, useEffect } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";

export default function (props) {
    const [ view, setView ] = useState(false);
    const multiplier = 86400000;
    const initialState = {
        from:new Date(new Date().getTime() - parseInt(30*multiplier)),
        to:new Date(new Date().getTime() + parseInt(1*multiplier))
    };
    const [ date, setDate ] = useState(initialState);

    useEffect(() => {
        if (props.startDate) {
            setDate({
                ...date,
                from:new Date(moment(props.startDate).format()),
                to:new Date(moment(props.endDate).format())
            })
        }
    },[props.startDate,props.endDate]);

    const onSetDate = (type,d) => {
        if (type === 'from') {
            setDate({...date, from:d})    
            props.onChange({...date, from:d});
        } else {
            setDate({...date, to:d})
            props.onChange({...date, to:d});
        }   
    };
    if (!props.open) {
        return null
    }
    return (
        <div className="border-bottom">
            <div className="bg-gray-100 py-2 px-4">
                <div className="form-row">
                    <div className="col-6">
                        <label>Tanggal Awal</label>
                        <DatePicker
                            className="form-control mb-2"
                            onChange={e => onSetDate('from',e)}
                            selected={date.from}
                        />
                    </div>
                    <div className="col-6">
                        <label>Tanggal Akhir</label>
                        <DatePicker
                            className="form-control mb-2"
                            onChange={e => onSetDate('to',e)}
                            selected={date.to}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};